module.exports = __webpack_public_path__ + "static/media/phone.458ea80b.png";